import { BondBlockerType } from '../../constants';
import { ModalConfig } from '../../types';

export const BOND_BLOCKER_CONFIG: Record<BondBlockerType, ModalConfig> = {
  [BondBlockerType.UNSPECIFIED]: {
    title: '',
    textColor: '',
    content: [],
    iconSrc: '',
  },
  [BondBlockerType.MAINTENANCE]: {
    title: 'Maintenance Sedang Berlangsung',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-maintenance.svg',
  },
  [BondBlockerType.MARKET_CLOSE]: {
    title: 'Market Sedang Tutup',
    textColor: '#333333',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-market-close.svg',
  },
  [BondBlockerType.PRICE_CHANGED]: {
    title: 'Terjadi Perubhan Harga',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-price-changed.svg',
  },
  [BondBlockerType.TEMPORARY_UNAVAILABLE]: {
    title: 'Sedang Tidak Tersedia',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-temporary-unavailable.svg',
  },
  [BondBlockerType.UNAVAILABLE]: {
    title: 'Sementara Tidak Dapat Dibeli',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-unavailable.svg',
  },
  [BondBlockerType.SHARIA_VALIDATION]: {
    title: 'Bukan FR Syariah',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-sharia.svg',
  },
  [BondBlockerType.STABLE_EARN]: {
    title: 'Produk Teridentifikasi Sebagai Stable Earn',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-stable-earn.svg',
  },
  [BondBlockerType.GENERAL_ERROR]: {
    title: 'Unable to Load Data',
    textColor: '',
    content: [],
    iconSrc: 'icon/fr/fr-blocker-general-error.svg',
  },
};
